import React from 'react';
import { getConfiguredSocialLinks } from '../../../utils/socialLinks.js';

export default function SocialLinks({ socialLinks, className = '', linkClassName = '' }) {
    const items = getConfiguredSocialLinks(socialLinks);

    if (!items.length) return null;

    return (
        <div className={className}>
            {items.map(({ key, Icon, label, href }) => (
                <a
                    key={key}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={linkClassName}
                    aria-label={label}
                >
                    <Icon />
                </a>
            ))}
        </div>
    );
}
